import React, { useState }  from 'react'
import { BiPlay,BiStop } from 'react-icons/bi'
export default function ABC(){
  const [loadingPlay1,setLoadingPlay1]=useState(false)
  const [loadingPlay2,setLoadingPlay2]=useState(false)
  const [loadingPlay3,setLoadingPlay3]=useState(false)
  const [loadingPlay4,setLoadingPlay4]=useState(false)
  const [test1,setTest1]=useState('w-[0px]')
  const [test2,setTest2]=useState('w-[0px]')
  const onClick2Loading3=()=>{
    setLoadingPlay3(true)
    setTest1('w-[30px]')
    setTimeout(() => {
      setLoadingPlay3(false)
    }, 1200)
  }
  const onClick2Loading4=()=>{
    setLoadingPlay4(true)
    setTimeout(() => {setTest2('w-[2.5px]')}, 100)
    setTimeout(() => {setTest2('w-[5px]')}, 200)
    setTimeout(() => {setTest2('w-[6.5px]')}, 300)
    setTimeout(() => {setTest2('w-[10px]')}, 400)
    setTimeout(() => {setTest2('w-[12.5px]')}, 500)
    setTimeout(() => {setTest2('w-[15px]')}, 600)
    setTimeout(() => {setTest2('w-[17.5px]')}, 700)
    setTimeout(() => {setTest2('w-[20px]')}, 800)
    setTimeout(() => {setTest2('w-[22.5px]')}, 900)
    setTimeout(() => {setTest2('w-[25px]')}, 1000)
    setTimeout(() => {setTest2('w-[27.5px]')}, 1100)
    setTimeout(() => {
      setTest2('w-[30px]')
      setLoadingPlay4(false)
    }, 1200)
  }
    return (
      <div className='text-left'>
      <h2 className='text-[12px] font-bold'>loading text</h2>
      <button className='border border-gray-800 hover:bg-gray-200' onClick={()=>setLoadingPlay1(!loadingPlay1)}>{loadingPlay1?<BiStop/>:<BiPlay/>}</button>
      {loadingPlay1?<p className='flex text-xs'>Please wait for 5seconds<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:''}
      <h2 className='text-[12px] font-bold'>loading circle icon</h2>
      <button className='border border-gray-800 hover:bg-gray-200' onClick={()=>setLoadingPlay2(!loadingPlay2)}>{loadingPlay2?<BiStop/>:<BiPlay/>}</button>
      {loadingPlay2?<div className='secondary-loader'></div>:''}
      <h2 className='text-[12px] font-bold'>loading bar</h2>
      <div className='flex m-auto mb-1'>
      <button className='border border-gray-800 hover:bg-gray-200' onClick={onClick2Loading3}>{loadingPlay3?<BiStop/>:<BiPlay/>}</button>
      <button className='text-[9px] pl-1 pr-1 ml-[2px] border border-gray-800 hover:bg-gray-200' onClick={()=>setTest1('w-[0px]')}>Reset</button>
      </div>
      <div className='static h-[10px]'>
      <div className='absolute block h-[10px] border border-gray-800 w-[30px]'></div>
      <div className={`absolute block cursor-default h-[10px] w-[0px] bg-gray-800 ${test1} ${loadingPlay3?'tertiary-loader':''}`}></div>
      </div>
      <h2 className='text-[12px] font-bold'>loading bar animation slides</h2>
      <div className='flex m-auto mb-1'>
      <button className='border border-gray-800 hover:bg-gray-200' onClick={onClick2Loading4}>{loadingPlay4?<BiStop/>:<BiPlay/>}</button>
      <button className='text-[9px] pl-1 pr-1 ml-[2px] border border-gray-800 hover:bg-gray-200' onClick={()=>setTest2('w-[0px]')}>Reset</button>
      </div>
      <div className='static h-[10px]'>
      <div className='absolute block h-[10px] border border-gray-800 w-[30px]'></div>
      <div className={`absolute block h-[10px] bg-gray-800 ${test2}`}></div>
      </div>
      </div>
    )
}